/* eslint-disable react-hooks/exhaustive-deps */
import i18n from "../../../plugins/locale/i18n";
import loadDictionary from "../../../plugins/locale/load-dictionary";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import BankAccountService from "../../../service/bank-account-service";
import Pasoonate from "pasoonate";
import ExcleJS from "exceljs";
import { saveAs } from "file-saver";

const bankAccountService = new BankAccountService();

await loadDictionary('bank-account-bon-card-transactions-page');

function BonCardTransactionsPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [transactionElements, setTransactionElements] = useState([]);
  const [bankAccount, setBankAccount] = useState(null);
  const [filterFromDay, setFilterFromDay] = useState(0);
  const [filterFromMonth, setFilterFromMonth] = useState(0);
  const [filterFromYear, setFilterFromYear] = useState(0);
  const [filterToDay, setFilterToDay] = useState(0);
  const [filterToMonth, setFilterToMonth] = useState(0);
  const [filterToYear, setFilterToYear] = useState(0);
  const exportData = useRef([]);
  const params = useParams();
  const monthOptions = useMemo(() => {
      const options = [];
      const monthList = Pasoonate.trans('jalali.month_name', 'fa');
      const currentMonth = Pasoonate.make().jalali().getMonth();
      
      for(let i in monthList) {
          options.push(<option key={i} value={i}>{monthList[i]}</option>);
      }

      setFilterFromMonth(currentMonth);
      setFilterToMonth(currentMonth);

      return options;
  }, []);
  const dayOptions = useMemo(() => {
      const options = [];
      const currentDay = Pasoonate.make().jalali().getDay();
      
      for(let i = 1; i <= 31; i++) {
          options.push(<option key={i} value={i}>{i}</option>);
      }

      setFilterFromDay(currentDay);
      setFilterToDay(currentDay);

      return options;
  }, []);

  const reloadList = (from, to) => {
    setIsLoading(true);
    const fromDate = from || new Date();
    const toDate = to || new Date();
    const bankAccountId = params.bankAccountId;

    bankAccountService.bonCardTransactions(bankAccountId, fromDate, toDate).then((result) => {
      let key = 1;
      const elements = result.map((transaction) =>
        <tr key={key++} >
          <td><div dir="ltr" className="text-end">{Pasoonate.make().gregorian(transaction.datetime).jalali().format('yyyy/MM/dd HH:mm:ss')}</div></td>
          <td>{transaction.type}</td>
          <td><div dir="ltr" className="text-end">{Number(transaction.amount).toLocaleString()}</div></td>
          <td>{transaction.bank}</td>
          <td>{transaction.terminal_code}</td>
          <td>{transaction.reference_number}</td>
          <td>{transaction.sequence_number}</td>
          <td>{transaction.status}</td>
        </tr>
      );
      
      setTransactionElements(elements);
      setCount(elements.length);
      setIsLoading(false);  
      exportData.current = result;
    }).catch((reason) => {
      exportData.current = [];
      console.log(reason);
    });
  };

  const filter = () => {
    const from = Pasoonate.make().jalali().setDateTime(filterFromYear, filterFromMonth, filterFromDay, 0, 0, 0).gregorian().getDateTime();
    const to = Pasoonate.make().jalali().setDateTime(filterToYear, filterToMonth, filterToDay, 23, 59, 59).gregorian().getDateTime();
    const fromDate = new Date(from.year, from.month - 1, from.day, from.hour, from.minute, from.second);
    const toDate = new Date(to.year, to.month - 1, to.day, to.hour, to.minute, to.second);

    reloadList(fromDate, toDate);
  };

  const downloadExcelFile = () => {
    const workbook = new ExcleJS.Workbook();

    workbook.creator = "Payment Service";
    workbook.created = new Date();

    const sheet = workbook.addWorksheet("sheet_1");
    sheet.views = [{rightToLeft: true}];

    const header = sheet.getRow(1);
    header.getCell(1).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.date");
    header.getCell(2).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.type");
    header.getCell(3).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.amount");
    header.getCell(4).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.terminal_name");
    header.getCell(5).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.terminal_code");
    header.getCell(6).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.reference_number");
    header.getCell(7).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.sequence_number");
    header.getCell(8).value = i18n.t("bank-account-bon-card-transactions-page.table_columns.status");

    exportData.current.forEach((item, index) => {
      const row = sheet.getRow(index + 2);

      row.getCell(1).value = Pasoonate.make().gregorian(item.datetime).jalali().format('yyyy/MM/dd HH:mm:ss');
      row.getCell(2).value = item.type;
      row.getCell(3).value = item.amount;
      row.getCell(4).value = item.bank;
      row.getCell(5).value = item.terminal_code;
      row.getCell(6).value = item.reference_number;
      row.getCell(7).value = item.sequence_number;
      row.getCell(8).value = item.status;

      row.getCell(3).numFmt = "#,###_);(#,###)";
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      saveAs(blob, "bon_card_ransactions.xlsx");
    });
  };
  
  useEffect(() => {
    const currentYear = Pasoonate.make().jalali().getYear();

    setFilterFromYear(currentYear);
    setFilterToYear(currentYear);

    bankAccountService.findOne(params.bankAccountId).then((result) => {
      setBankAccount(result);
    }).catch((reason) => {
      console.log(reason);
    });

    reloadList();    
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body border-bottom p-3 pb-0">
        <div className="row mb-4">
          <div className="col">
            <h4 className="page-title">{i18n.t("bank-account-bon-card-transactions-page.page_title", {bankAccountName: bankAccount ? bankAccount.name : ""})}</h4>
          </div>
          <div className="col-auto">
            <a className="link-secondary link-offset-1 link-underline-opacity-50" href="/bank-accounts">{i18n.t("bank-account-bon-card-transactions-page.bank_accounts_page_link")}</a>
          </div>
        </div>
        <div className="row mb-1">
          <div className="table-filter col-auto">
            <div className="row g-2">
              <div className="col-auto">
                <label className="form-label">از تاریخ</label>
                <div className="input-group mb-3">
                  <select className="form-select" value={filterFromDay} onChange={(e) => {setFilterFromDay(e.target.value)}}>
                    {dayOptions}
                  </select>
                  <select className="form-select" value={filterFromMonth} onChange={(e) => {setFilterFromMonth(e.target.value)}}>
                    {monthOptions}
                  </select>
                  <input type="text" dir="ltr" className="form-control" value={filterFromYear} placeholder="سال"  onChange={(e) => {setFilterFromYear(e.target.value)}}/>
                </div>
              </div>
              <div className="col-auto">
                <label className="form-label">تا تاریخ</label>
                <div className="input-group mb-3">
                  <select className="form-select" value={filterToDay} onChange={(e) => {setFilterToDay(e.target.value)}}>
                    {dayOptions}
                  </select>
                  <select className="form-select" value={filterToMonth} onChange={(e) => {setFilterToMonth(e.target.value)}}>
                    {monthOptions}
                  </select>
                  <input type="text" dir="ltr" className="form-control" value={filterToYear} placeholder="سال" onChange={(e) => {setFilterToYear(e.target.value)}}/>
                </div>
              </div>
              <div className="col-12 col-sm-auto">
                <label className="form-label d-none d-sm-inline-block">&nbsp;</label>
                <div className="d-grid mb-3">
                  <button type="submit" className={"btn btn-primary" + (isLoading ? " disabled" : "")} onClick={filter}>اعمال</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("bank-account-bon-card-transactions-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'disabled' : '')} type="button" onClick={downloadExcelFile}><i className="bi bi-download"></i></button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.date")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.type")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.amount")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.terminal_name")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.terminal_code")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.reference_number")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.sequence_number")}</th>
                <th>{i18n.t("bank-account-bon-card-transactions-page.table_columns.status")}</th>
              </tr>
            </thead>
            <tbody>{transactionElements}</tbody>
          </table>
        </div>
      </div>
    </div>
  );

}

export default BonCardTransactionsPage;